<div class="searchdiv">
  <div class="headerdiv">
    <h1>
      {{ screenTitle }}
    </h1>
    <div id="ErrorDiv" class="ErrorDiv"></div>

    <div class="bothbuttdiv">
      <button
        [disabled]=""
        class="btn btn-primary commonbutt"
        type="button"
        (click)="changePassWord()"
      >
        <em class="fa fa-check"></em>&nbsp;Submit
      </button>
      <button
        class="btn btn-danger commonbutt"
        (click)="closeButton()"
        type="button"
      >
        <em class="fa fa-times"></em>&nbsp;Close
      </button>
    </div>
  </div>

  <div class="card-body">
    <div class="row">
      <div class="col-md-12">
        <div class="form-div">
          <div class="row">
            <div class="m-portlet">
              <div class="col-lg-4">
                <label class="">Enter Your Current Password</label>
                <input
                  maxlength="125"
                  [(ngModel)]="screen_details.CURRENT_PASSWORD"
                  id="CURRENT_PASSWORD"
                  type="password"
                  [pattern]="namePattern"
                  #CURRENT_PASSWORD="ngModel"
                  class="form-control m-input"
                  placeholder="Current Password"
                />
              </div>
              <div class="col-lg-4">
                <label class="">Enter Your New Password</label>
                <input
                  maxlength="125"
                  [(ngModel)]="screen_details.NEW_PASSWORD"
                  id="NEW_PASSWORD"
                  type="password"
                  [pattern]="namePattern"
                  #NEW_PASSWORD="ngModel"
                  class="form-control m-input"
                  placeholder="New Password"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
